@switch (mode) {
  @case (LabelMode.DEFAULT) {
    <ng-container [ngTemplateOutlet]="default"></ng-container>
  }
  @case (LabelMode.INLINE) {
    <ng-container [ngTemplateOutlet]="inline"></ng-container>
  }
  @case (LabelMode.NO_LABEL) {
    <ng-container [ngTemplateOutlet]="input"></ng-container>
  }
}

<ng-template #input>
  <div class="demo-inline-spacing" [ngClass]="inputClass">
    @for (option of options; track option.id; let i = $index) {
      <div class="custom-radio-wrapper mb-1">
        <div class="form-check form-check-custom form-check-sm">
          <input
            type="radio"
            [id]="name + i"
            [name]="name"
            [value]="option.id"
            class="form-check-input"
            [formControl]="form"
          />
          <label
            class="custom-control-label fs-form-control ms-2"
            [for]="name + i"
            >{{ option.name }}</label
          >
        </div>
      </div>
    }
    @if (options?.length === 0) {
      <p class="text-muted m-0">- {{ "APP.NO_DATA" | translate }} -</p>
    }
  </div>
</ng-template>

<ng-template #mainLabel>
  @if (labelValue) {
    <label
      [for]="name"
      class="col-form-label fw-bold fs-6 py-2 w-100 text-start"
      [ngClass]="required ? 'required' : ''"
      >{{ label | translate: { value: labelValue } }}</label
    >
  }
  @if (!labelValue) {
    <label
      [for]="name"
      [class]="`col-form-label  py-2 w-100 text-start ${labelStyle}`"
      [ngClass]="required ? 'required' : ''"
      >{{ label | translate }}</label
    >
  }
</ng-template>

<ng-template #default>
  <div class="form-group" [ngClass]="classes">
    <ng-container [ngTemplateOutlet]="mainLabel"></ng-container>
    <ng-container [ngTemplateOutlet]="input"></ng-container>
  </div>
</ng-template>

<ng-template #inline>
  <div class="form-group form-group-inline">
    <ng-container [ngTemplateOutlet]="mainLabel"></ng-container>

    <ng-container [ngTemplateOutlet]="input"></ng-container>
  </div>
</ng-template>
